import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Images/google.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = { class: "h-screen rounded shadow-2xl flex flex-col justify-center items-end w-full px-20" }
const _hoisted_3 = { class: "h-3/4 shadow-form flex flex-col justify-center w-96 bg-white px-8 py-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-slate-900 font-normal mt-8" }, " Hello, Welcome to You-Read. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-slate-900" }, " Create Account ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "rounded-md mt-3 border bg-boxColor text-sm text-white p-3 w-full sx:w-[90%]"
}, " Sign Up ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-sm font-normal text-slate-900" }, " or ", -1)
const _hoisted_8 = { class: "w-full mt-3 gap-4 flex justify-center items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5",
  src: _imports_0,
  alt: "google"
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "text-[14px] cursor-pointer bg-[rgb(160,0,109)] rounded-[4px] px-4 py-1",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.modal && $options.modal(...args)))
    }, " Sign Up "),
    ($data.toggleModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _cache[6] || (_cache[6] = $event => ($data.toggleModal = false))
        }, {
          header: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("form", {
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => ($options.signUp && $options.signUp(...args)), ["prevent"]))
                }, [
                  _hoisted_4,
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.args.name) = $event)),
                    placeholder: "Fullname",
                    type: "text",
                    required: "",
                    class: "rounded-md mt-6 border bg-transparent border-gray-400 text-sm text-gray-500 p-2 w-full sx:w-[90%]"
                  }, null, 512), [
                    [_vModelText, $data.args.name]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.args.email) = $event)),
                    placeholder: "Email address",
                    type: "email",
                    required: "",
                    class: "rounded-md mt-6 border bg-transparent border-gray-400 text-sm text-gray-500 p-2 w-full sx:w-[90%]"
                  }, null, 512), [
                    [_vModelText, $data.args.email]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.args.password) = $event)),
                    placeholder: "password",
                    type: "password",
                    required: "",
                    class: "rounded-md border bg-transparent border-gray-400 mt-2 text-sm text-gray-500 p-2 w-full sx:w-[90%]"
                  }, null, 512), [
                    [_vModelText, $data.args.password]
                  ]),
                  _hoisted_6
                ], 32),
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "w-full sx:w-[90%] gap-4 flex text-slate-900 border text-sm border-gray-400 py-3 rounded-md justify-center items-center",
                    onClick: _cache[5] || (_cache[5] = (...args) => ($options.signUpWithGoogle && $options.signUpWithGoogle(...args)))
                  }, [
                    _hoisted_9,
                    _createTextVNode(" Signup With Google ")
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}